import React, { ReactElement } from 'react';
import { Box, Fade, Link, useMediaQuery, useTheme } from '@material-ui/core';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import defaultLocales from 'globals/locales/default';
import FsPaper from 'ui-elements/main-elements/FsPaper';
import FsButton from 'ui-elements/buttons/FsButton';
import { SubTitle } from 'ui-elements/main-elements/FsPaper/FsPaper.style-elements';
import FsWebOriginForm from 'ui-elements/forms/FsWebOriginForm';
import FsMobileOriginForm from 'ui-elements/forms/FsMobileOriginForm';

// Locales
const { developersPage: developerLocales } = defaultLocales;
const {
  redirects: { webOrigin: webOriginLocales, iOsAndroid: iOsAndroidLocales },
} = developerLocales;

interface RedirectsProps {
  inStatus: boolean;
  timeout?: number;
}

const getButtons = (isUpSm: boolean): Array<ReactElement> => [
  <FsButton
    color="primary"
    key={1}
    href={developerLocales.redirects.docsUrl}
    startIcon={<DescriptionOutlinedIcon />}
    whiteSpace
  >
    {isUpSm ? defaultLocales.readDocs : defaultLocales.docs}
  </FsButton>,
];

const webOriginSubtitle = (
  <>
    <SubTitle>
      {webOriginLocales.descriptionPrefix}{' '}
      <Link href={webOriginLocales.url}>
        {webOriginLocales.descriptionSuffix}
      </Link>{' '}
      {webOriginLocales.descriptionSuffix}
    </SubTitle>
    <SubTitle>{webOriginLocales.descriptionNextLine}</SubTitle>
  </>
);
const mobileOriginSubtitle = (
  <>
    <SubTitle>
      {iOsAndroidLocales.descriptionPrefix}{' '}
      <Link href={iOsAndroidLocales.iOsUrl}>
        {iOsAndroidLocales.iOsLinkLabel}
      </Link>{' '}
      {iOsAndroidLocales.descriptionSuffix}{' '}
      <Link href={iOsAndroidLocales.iOsUrl}>
        {iOsAndroidLocales.androidLinkLabel}
      </Link>
      .
    </SubTitle>
  </>
);

const Redirects: React.FC<RedirectsProps> = ({ inStatus, timeout = 1000 }) => {
  const theme = useTheme();
  const isUpSm = useMediaQuery(theme.breakpoints.up('sm'), {
    noSsr: true,
  });
  const buttons = getButtons(isUpSm);

  return (
    <>
      <Box marginBottom={4}>
        <Fade in={inStatus} timeout={timeout}>
          <FsPaper
            title={webOriginLocales.title}
            subTitle={webOriginSubtitle}
            buttons={buttons}
          >
            <FsWebOriginForm />
          </FsPaper>
        </Fade>
      </Box>

      <Fade in={inStatus} timeout={timeout}>
        <FsPaper
          title={iOsAndroidLocales.title}
          subTitle={mobileOriginSubtitle}
          buttons={buttons}
        >
          <FsMobileOriginForm />
        </FsPaper>
      </Fade>
    </>
  );
};

export default Redirects;
